import React, { useEffect } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { isMobile } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions";

import '../../assets/css/0010_sections/460_section_particles-home.css';

const PageEventBirthDay = () => {

	useEffect(() => {
		const script = document.createElement("script");
		script.src = "https://cdn.jsdelivr.net/npm/tsparticles@1.43.1/tsparticles.min.js";
		script.async = true;
		script.onload = () => initTsParticles();
		document.body.appendChild(script);
	}, []);

	const initTsParticles = () => {

		const tsParticles = window.tsParticles;
		
		const defaultOptions = {
			fpsLimit: 60,
			detectRetina: true,
		};

		const emittersOptions = {
			life: {
				count: 1,
				duration: 0.1,
			},
			rate: {
				quantity: 100,
				delay: 0.1,
			},
		};

		const particlesOptions = {
			number: {
				value: 0,
			},
			// color: {
			// 	value: "#00ACC2"
			// },
			shape: {
				type: ["square"],
			},
			opacity: {
				value: { min: 0, max: 1 },
				animation: {
					enable: true,
					speed: 1,
					startValue: "max",
					destroy: "min"
				}
			},
			size: {
				value: { min: isMobile() ? 3 : 5, max: isMobile() ? 6 : 10 }
			},
			move: {
				enable: true,
				gravity: {
					enable: true,
				},
				drift: {
					min: -2,
					max: 2,
				},
				speed: { min: 10, max: 30 },
				decay: 0.1,
				direction: "none",
				random: false,
				straight: false,
				outModes: {
					default: "destroy",
					top: "none",
				}
			},
			rotate: {
				value: {
					min: 0,
					max: 360,
				},
				direction: "random",
				move: true,
				animation: {
					enable: true,
					speed: 60,
				}
			},
			tilt: {
				direction: "random",
				enable: true,
				move: true,
				value: {
					min: 0,
					max: 360,
				},
				animation: {
					enable: true,
					speed: 60,
				}
			},
			roll: {
				darken: {
					enable: true,
					value: 10,
				},
				enable: true,
				speed: {
					min: 15,
					max: 25,
				}
			},
			wobble: {
				distance: 30,
				enable: true,
				move: true,
				speed: {
					min: -15,
					max: 15,
				}
			}
		};

		const createTsParticles = (id, position, color) => {
			tsParticles.load(id, {
				...defaultOptions,
				emitters: {
					...emittersOptions,
					position: position,
				},
				particles: {
					...particlesOptions,
					color: {
						value: color,
					},
				}
			});
		}

		const particlesColors = [
			'#D784EB',
			'#6A3691',
			'#0052A2',
			'#3F6FD5',
			'#6EC3FF',
			'#204FD5',
			'#6FE2E9',
			'#00A261',
			'#82E87E',
			'#CAFF6E',
		];


		setTimeout(() => {
			document.querySelector('.message_particles-home').classList.add('is-visible');
			window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
			createTsParticles('tsparticles-1', {x: 35, y: 25}, particlesColors[7]);
		}, 1000 * 2);
		//
		setTimeout(() => {
			createTsParticles('tsparticles-2', {x: 75, y: 30}, particlesColors[4]);
		}, 1000 * 2.75);
		setTimeout(() => {
			createTsParticles('tsparticles-3', {x: 55, y: 35}, particlesColors[7]);
		}, 1000 * 3);
		setTimeout(() => {
			createTsParticles('tsparticles-4', {x: 40, y: 25}, particlesColors[1]);
		}, 1000 * 3.25);
		setTimeout(() => {
			createTsParticles('tsparticles-5', {x: 30, y: 50}, particlesColors[8]);
		}, 1000 * 3.5);
		//
		setTimeout(() => {
			createTsParticles('tsparticles-6', {x: 70, y: 45}, particlesColors[6]);
		}, 1000 * 4.25);
		setTimeout(() => {
			createTsParticles('tsparticles-7', {x: 35, y: 30}, particlesColors[9]);
		}, 1000 * 4.5);
		//
		setTimeout(() => {
			createTsParticles('tsparticles-8', {x: 60, y: 25}, particlesColors[9]);
		}, 1000 * 5.25);
		setTimeout(() => {
			createTsParticles('tsparticles-9', {x: 35, y: 55}, particlesColors[5]);
		}, 1000 * 5.5);
		setTimeout(() => {
			createTsParticles('tsparticles-10', {x: 50, y: 30}, particlesColors[0]);
		}, 1000 * 5.75);
		//
		setTimeout(() => {
			createTsParticles('tsparticles-11', {x: 65, y: 50}, particlesColors[2]);
		}, 1000 * 6.5);			
		setTimeout(() => {
			createTsParticles('tsparticles-12', {x: 45, y: 40}, particlesColors[3]);
		}, 1000 * 6.75);
		//
		setTimeout(() => {
			document.querySelector('.message_particles-home').classList.remove('is-visible');
		}, 1000 * 10);

	}

	return(
		<div className="section_particles-home">
			<div className="canvas_particles-home" id="tsparticles-1"></div>
			<div className="canvas_particles-home" id="tsparticles-2"></div>
			<div className="canvas_particles-home" id="tsparticles-3"></div>
			<div className="canvas_particles-home" id="tsparticles-4"></div>
			<div className="canvas_particles-home" id="tsparticles-5"></div>
			<div className="canvas_particles-home" id="tsparticles-6"></div>
			<div className="canvas_particles-home" id="tsparticles-7"></div>
			<div className="canvas_particles-home" id="tsparticles-8"></div>
			<div className="canvas_particles-home" id="tsparticles-9"></div>
			<div className="canvas_particles-home" id="tsparticles-10"></div>
			<div className="canvas_particles-home" id="tsparticles-11"></div>
			<div className="canvas_particles-home" id="tsparticles-12"></div>
			<div className="message_particles-home">
				<img className="i_cake-birthday" src={require("../../assets/images/i_cake-birthday.jpg")} alt=""/>
				<p className="t_title">1 an ensemble !</p>
				<p className="t_desc">Merci pour votre fidélité et votre confiance. Continuons l'aventure !</p>
			</div>
		</div>
	);

};

export default (withSitecoreContext()(PageEventBirthDay));